<template>
    <div id="slideBarNavigation">
        <div id="mainSidenav" class="sidenav">
            <div style="width: 100%;height: 15px">
                <a href="javascript:void(0)" class="closebtn" v-on:click="closeNav()">&times;</a>
            </div>
            <span>
            <a  v-on:click="changePage('/')">صفحه ی اصلی</a>
            </span>
            <span>
                <a v-if="$store.state.loginStatus" v-on:click="isActiveRun('profile')"
                            v-bind:style="[isActive.type==='profile' && isActive.status ? {color:'white'} : {color:''}]">
                پروفایل کاربری
                         <img v-if="isActive.type==='profile' && isActive.status" width="7" height="5"
                              src="../assets/appIcons/Icon/Filled/ArrowUp.png" alt="">
                <img v-else width="7" height="5" src="../assets/appIcons/Icon/Filled/ArrowDown.png" alt="">
                <transition name="fade">
                    <ul v-if="isActive.type==='profile' && isActive.status">
                        <li>
                            <div v-on:click="changePage('/user-panel')" class="navigation-menu-text-content">
                                <div class="navigation-menu-icon-content">
                                    <img class="arrow" width="12" height="7"
                                         src="../assets/appIcons/Icon/Filled/ArrowWhite.png" alt="">
                                </div>
                             داشبورد
                            </div>
                            <div v-on:click="changePage('/user-panel/edit-personal-infos')"
                                 class="navigation-menu-text-content">
                                <div class="navigation-menu-icon-content">
                                    <img class="arrow" width="12" height="7"
                                         src="../assets/appIcons/Icon/Filled/ArrowWhite.png" alt="">
                                </div>
                              ویرایش اطلاعات
                            </div>
                            <div v-on:click="changePage('/user-panel/saved-articles')"
                                 class="navigation-menu-text-content">
                                <div class="navigation-menu-icon-content">
                                    <img class="arrow" width="12" height="7"
                                         src="../assets/appIcons/Icon/Filled/ArrowWhite.png" alt="">
                                </div>
                              مقالات ذخیره شده
                            </div>
                            <div style="display: flex;align-items: center;" v-on:click="changePage('/user-panel/conversation-with-experts/chatting')"
                                 class="navigation-menu-text-content">
                                <div class="navigation-menu-icon-content">
                                    <img class="arrow" width="12" height="7"
                                         src="../assets/appIcons/Icon/Filled/ArrowWhite.png" alt="">
                                </div>
                               گفتگو
                                <span v-if="$store.state.notificationDetails.unreadMessagesCount > 0" class="new-messages-count">{{$store.state.notificationDetails.unreadMessagesCount}}</span>
                            </div>
                            <div v-on:click="changePage('/user-panel/user-bills')" class="navigation-menu-text-content">
                                <div class="navigation-menu-icon-content">
                                    <img class="arrow" width="12" height="7"
                                         src="../assets/appIcons/Icon/Filled/ArrowWhite.png" alt="">
                                </div>
                                صورت حساب ها
                            </div>
                            <div v-on:click="changePage('/user-panel/user-documents')"
                                 class="navigation-menu-text-content">
                                <div class="navigation-menu-icon-content">
                                    <img class="arrow" width="12" height="7"
                                         src="../assets/appIcons/Icon/Filled/ArrowWhite.png" alt="">
                                </div>
                                مدارک
                            </div>
                            <div v-on:click="changePage('/user-panel/advanced-search')"
                                 class="navigation-menu-text-content">
                                <div class="navigation-menu-icon-content">
                                    <img class="arrow" width="12" height="7"
                                         src="../assets/appIcons/Icon/Filled/ArrowWhite.png" alt="">
                                </div>
                                جست و جوی پیشرفته
                            </div>
                            <div v-on:click="changePage('/user-panel/logout')" class="navigation-menu-text-content">
                                <div class="navigation-menu-icon-content">
                                    <img class="arrow" width="12" height="7"
                                         src="../assets/appIcons/Icon/Filled/ArrowWhite.png" alt="">
                                </div>
                               خروج
                            </div>
                        </li>
                    </ul>
                </transition>
            </a>
            </span>

            <span v-if="categories">
                <a  v-for="(category , index) in categories" :key="category" v-on:click="isActiveRun(index)"
                   v-bind:style="[isActive.type===index && isActive.status ? {color:'white'} : {color:''}]">



                {{category.name}}

                        <img v-if="isActive.type===index && isActive.status" width="7" height="5"
                             src="../assets/appIcons/Icon/Filled/ArrowUp.png" alt="">
                <img v-else width="7" height="5" src="../assets/appIcons/Icon/Filled/ArrowDown.png" alt="">


                <transition name="fade">
                    <ul v-if="isActive.type===index && isActive.status">
                        <li v-if="category.subcategories">


                            <div class="navigation-menu-text-content" v-on:click="changePage('/category-view/'+category.slug)">
                             صفحه ی مرتبط
                                <div class="navigation-menu-icon-content">
                                    <img class="arrow" width="12" height="7"
                                         src="../assets/appIcons/Icon/Filled/ArrowWhite.png" alt="">
                                </div>
                            </div>

                            <div class="navigation-menu-text-content" v-for="subcategory in category.subcategories"
                                 v-on:click="changePage('/category-view/'+ subcategory.slug)" :key="subcategory">
                                {{subcategory.name}}
                                 <div class="navigation-menu-icon-content">
                                    <img class="arrow" width="12" height="7"
                                         src="../assets/appIcons/Icon/Filled/ArrowWhite.png" alt="">
                                </div>
                            </div>
                        </li>
                    </ul>
                </transition>
            </a>
            </span>

            <span>
            <a  v-on:click="changePage('/about-us')">درباره ما</a>
            </span>
        </div>
        <div id="open-nav-btn-icon" style="font-size:30px;cursor:pointer">
            <div  v-on:click="openNav()">
                &#9776;
            </div>
            <div v-if="$route.name!=='Register' && $route.name!=='Login' && $route.name!=='PersonalInfo'  && $route.name!=='ForgetPassword'  && $route.name!=='ChangePassword'">
                <SearchInput/>
            </div>
        </div>
    </div>
</template>

<script>
    import SearchInput from '../components/SearchInput'
    export default {
        name: "SlideBarNavigation",
        data() {
            return {
                isActive: {type: '', status: false},
            }
        },
        components:{SearchInput},
        props: ['categories'],
        methods: {
            isActiveRun: function (type) {
                this.isActive.type = type;
                this.isActive.status = !this.isActive.status;
            },
            openNav: function () {
                document.getElementById("mainSidenav").style.width = "300px";
            },
            closeNav: function () {
                document.getElementById("mainSidenav").style.width = "0";
            },
            changePage: function (direction) {
                this.closeNav();
                //direction
                this.$router.push(direction)
            }
        },
    }
</script>

<style scoped>
    .new-messages-count {
        color: red;
        position: absolute;
        right: 50px;
        width: 30px;
        height: 30px;
        background-color: beige;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .navigation-menu-text-content {
        display: block;
    }

    #slideBarNavigation {
        position: relative;
        z-index: 1000000;
    }

    #open-nav-btn-icon {
        display: none;
        margin-top: 0px;
    }

    .sidenav {
        height: 100%;
        width: 0;
        position: fixed;
        z-index: 1;
        top: 0;
        right: 0;
        background-color: #162336;
        overflow-x: hidden;
        transition: 0.5s;
        padding-top: 60px;
        /*box-shadow: -1px -1px 5px 1px #e3e3e3;*/
    }

    .sidenav .closebtn {
        position: absolute;
        top: 0;
        left: 25px;
        font-size: 40px;
        margin-right: 50px;
        float: left;
    }

    @media screen and (max-height: 450px) {
        .sidenav {
            padding-top: 15px;
        }

        .sidenav a {
            font-size: 18px;
        }
    }

    #mainSidenav > span > a {
        font-size: 20px;
        text-align: right;
        width: 300px;
    }

    #mainSidenav > span > a > ul {
        list-style-type: none;
        padding-right: 15px;
        /*display: none;*/
    }

    #mainSidenav > span > a > ul > li {
        width: 100%;
        min-height: 40px;
        font-size: 17px;
        line-height: 40px;
    }

    .sidenav a {
        cursor: pointer;
        padding: 8px 32px 8px 8px;
        text-decoration: none;
        font-size: 25px;
        color: #818181;
        display: block;
        transition: 0.3s;
    }

    .sidenav a:hover {
        color: #f1f1f1;
    }

    .navDetails {
        display: none;
    }

    @media (max-width: 1300px) {
        #open-nav-btn-icon {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }

    @media (min-width: 1300px) {
        .sidenav {
            box-shadow: none;
        }
    }
</style>